// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-color-item {
  --color-item-size: 28px;
  background-clip: padding-box;
  background-color: var(--g-color-base-float);
  width: var(--color-item-size);
  height: var(--color-item-size);
  overflow: hidden;
  border-radius: 6px;
}
.dl-color-item_size_max {
  --color-item-size: 100%;
}
.dl-color-item_with-external-border {
  border: 1px solid transparent;
}
.dl-color-item__bg-item {
  display: inline-block;
  width: 100%;
  height: 100%;
  background-clip: padding-box;
}
.dl-color-item__bg-item_transparent {
  background-image: repeating-conic-gradient(var(--g-color-base-generic) 0 25%, var(--g-color-base-background) 0 50%);
}`, "",{"version":3,"sources":["webpack://./src/ui/units/dash/containers/Dialogs/components/ColorPalette/ColorItem/ColorItem.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EAEA,4BAAA;EACA,2CAAA;EACA,6BAAA;EACA,8BAAA;EACA,gBAAA;EAEA,kBAAA;AADJ;AAGI;EACI,uBAAA;AADR;AAII;EACI,6BAAA;AAFR;AAKI;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;AAHR;AAKQ;EACI,mHAAA;AAHZ","sourcesContent":[".dl-color-item {\n  --color-item-size: 28px;\n  background-clip: padding-box;\n  background-color: var(--g-color-base-float);\n  width: var(--color-item-size);\n  height: var(--color-item-size);\n  overflow: hidden;\n  border-radius: 6px;\n}\n.dl-color-item_size_max {\n  --color-item-size: 100%;\n}\n.dl-color-item_with-external-border {\n  border: 1px solid transparent;\n}\n.dl-color-item__bg-item {\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  background-clip: padding-box;\n}\n.dl-color-item__bg-item_transparent {\n  background-image: repeating-conic-gradient(var(--g-color-base-generic) 0 25%, var(--g-color-base-background) 0 50%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
